import { render, staticRenderFns } from "./ListsPage.vue?vue&type=template&id=16c0baa4&scoped=true"
import script from "./ListsPage.vue?vue&type=script&lang=ts"
export * from "./ListsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0baa4",
  null
  
)

export default component.exports